import React from 'react';
import PropTypes from 'prop-types';
import { useRoutes, Navigate } from 'react-router-dom';
import ROUTE_PATH from '../config/routes.config';
import LoginView from '../views/auth/login.view';
import DashboardView from '../views/dashboard/dashboard.view';
import ContentVideosView from '../views/content/videos.view';
import AdminUsersView from '../views/admin-users/admin-users.view';
import PageNotFoundView from '../views/errors/not-found.view';
import LogoutView from '../views/auth/logout.view';
import ContentChannelsView from '../views/content/channels.view';
// import ContentSequenceView from '../views/content/sequence.view';
import {
  ADMIN_USER_ROLE,
  SHOW_ADMIN_USERS,
  SHOW_CONTENT_CHANNELS,
  SHOW_CONTENT_VIDEOS,
  SHOW_OVERVIEW_DASHBOARD,
} from '../config/const.config';
import { checkAdminUserRole } from '../utils/local-cache.util';

const AppRouter = ({ isLoggedIn }) => {
  const routeMappings = [];

  const adminUserRole = checkAdminUserRole();

  if (isLoggedIn) {
    routeMappings.push({
      path: ROUTE_PATH.LOGIN,
      element: (
        <Navigate
          to={
            adminUserRole === 'ADMIN'
              ? ROUTE_PATH.DASHBOARD
              : ROUTE_PATH.CONTENT_VIDEOS
          }
        />
      ),
      exact: true,
    });

    if (SHOW_OVERVIEW_DASHBOARD) {
      routeMappings.push({
        path: ROUTE_PATH.DASHBOARD,
        element: <DashboardView adminUserRole={adminUserRole} />,
        exact: true,
      });
    }

    if (SHOW_CONTENT_CHANNELS) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_CHANNELS,
        element: <ContentChannelsView />,
        exact: true,
      });
    }

    if (SHOW_CONTENT_VIDEOS) {
      routeMappings.push({
        path: ROUTE_PATH.CONTENT_VIDEOS,
        element: <ContentVideosView  />, // videoContentType="VIDEO"
        exact: true,
      });
    }

    if (SHOW_ADMIN_USERS && adminUserRole === ADMIN_USER_ROLE.ADMIN) {
      routeMappings.push({
        path: ROUTE_PATH.ADMIN_USERS,
        element: <AdminUsersView />,
        exact: true,
      });
    }

    
    routeMappings.push({
      path: ROUTE_PATH.LOGOUT,
      element: <LogoutView />,
      exact: true,
    });
  }

  routeMappings.push({
    path: '*',
    element: isLoggedIn ? (
      <PageNotFoundView adminUserRole={adminUserRole} />
    ) : (
      <LoginView />
    ),
  });

  const routes = useRoutes(routeMappings);

  return routes;
};

AppRouter.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  categoriesTab: PropTypes.array.isRequired,
  rerenderComponent: PropTypes.func.isRequired,
};

export default AppRouter;
